<template>
  <div class="modal-card" style="width: auto">
    <div class="modal-card-head">
      <span class="title is-3 has-text-black"
        >{{
          $t("processingSteps.processingStepsFor", {
            name: cartItem.model.name,
          })
        }}
        <span class="has-text-info is-size-5"
          >{{$t("processingSteps.notWorkingDemoVersion")}}
          </span
        >
      </span>
    </div>
    <div class="modal-card-body">
      <div class="info-list my-4 has-text-black">
        <div
          v-for="(step, stepIndex) in availableProcessingSteps"
          :key="`processing-step__${stepIndex}`"
          class="info-list__item has-background-white p-4 pb-6"
        >
          <add-step :step="step" :cart-item-id="cartItemId"></add-step>
          <div
            class="divider has-background-grey mt-5"
            style="width: 100%"
          ></div>
        </div>
      </div>
      <div
        v-for="(step, index) in cartItem.processingSteps"
        :key="`processing-step-option_${index}`"
      >
        <span class="property__value">{{ step.quantity }}</span> x
        <span class="property__label">{{ step.option.name }}</span>
      </div>
    </div>
    <div class="modal-card-foot is-justify-content-flex-end">
      <button class="button is-rounded is-primary-dark" @click="close()">
        {{ $t("processingSteps.actionLabels.saveConfiguration") }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "../../../events/event-bus";
import NumberInput from "../../shared/NumberInput";
import AddStep from "./AddStep";

export default {
  name: "ConfigureProcessingSteps",
  components: {
    AddStep,
    NumberInput,
  },
  data() {
    return {
      apiBaseUrl: process.env.VUE_APP_FULFILLMENT_API_BASE_URL,
      cartItemQuantity: 0,
    };
  },
  props: {
    cartItemId: {
      type: String,
      required: true,
    },
  },
  methods: {
    close() {
      eventBus.$emit("close-modal-event");
      this.$parent.close();
    },
  },
  computed: {
    ...mapGetters(["cartItemByID", "printModeById"]),
    cartItem: {
      get() {
        return this.cartItemByID(this.cartItemId);
      },
      async set(value) {
        await this.$store.dispatch("updateCartItemByID", {
          cartItemId: this.cartItemId,
          ...value,
        });
        await this.$store.dispatch("persistCartItemByID", {
          cartItemId: this.cartItemId,
        });
      },
    },
    availableProcessingSteps() {
      return (
        this.printModeById(this.cartItem.printMode.id).processingSteps || []
      );
    },
  },
  async created() {},
};
</script>

<style lang="scss"></style>
